import React from "react";
import {  Grid  } from "semantic-ui-react";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import { FormTitle } from "@commonComponents/FormTitle";
import { useSelector } from "react-redux";
import { selectTerminalList } from "../selectors";

export const TerminalForm=React.memo(({translate,className='',disable,onSelect,terminal})=>{
const terminalList=useSelector(selectTerminalList)
 return (
  <div className={`${className} col formContainer`}>
         <FormTitle className="formTitle" title=" " textAlign="start" />
         <Grid.Row>
          <Grid.Column>
          <DropDown
                id="terminal"
                label={translate("TERMINAL", {ns:["default", "header"]})}
                clearable
                name="terminal"
                labelClass="text-none"

                data={terminalList}
                isDisabled={!disable}
                 value={terminal}
                 text={terminal}
                 onChange={onSelect}
        />
         
          </Grid.Column>
        </Grid.Row>
        </div>
  )
})

TerminalForm.defaultProps = {
  translate:(value)=>value
}